import { useMethods } from 'react-use';

import useSearchParams from '@/hooks/useSearchParam';

import { ERROR_KEY, ERROR_KEY_VALUE } from '../../../Peer/types';

export enum ExerciseDialogs {
  ApproveAndSubmit = 'APPROVE_AND_SUBMIT',
  AskToRetry = 'ASK_TO_RETRY',
  SubmissionHistory = 'SUBMISSION_HISTORY',
  FeatureSubmission = 'FEATURE_SUBMISSION',
  // AlreadyFeatured = 'ALREADY_FEATURED',
  RemoveFeatured = 'REMOVE_FEATURED',
  ScorecardEmpty = 'SCORECARD_EMPTY',
  CurrentlyReviewing = 'CURRENTLY_REVIEWING',
  SubmissionAlreadyReviewed = 'SUBMISSION_ALREADY_REVIEWED',
  AlreadyReviewed = 'ALREADY_REVIEWED',
  SubmissionDetails = 'SUBMISSION_DETAILS',
  PendingPeerReviews = 'PENDING_PEER_REVIEWS',
  CantEditSubmission = 'CANT_EDIT_SUBMISSION',
  EditSubmission = 'EDIT_SUBMISSION',
  SubmissionFeedback = 'SUBMISSION_FEEDBACK',
}

export interface ExerciseReviewState {
  inViewDialog: ExerciseDialogs | null;
  showErrors: boolean;
  name: string;
  suppressReviewDialog: boolean;
}

export const initialState: ExerciseReviewState = {
  inViewDialog: null,
  showErrors: false,
  suppressReviewDialog: false,
  name: '',
};

function createMethods(state: ExerciseReviewState) {
  return {
    setConcurrentDialogState(payload: {
      dialogType: ExerciseDialogs | null;
      name: string;
    }): ExerciseReviewState {
      return { ...state, inViewDialog: payload.dialogType, name: payload.name };
    },
    setVisibleDialog(dialog: ExerciseDialogs): ExerciseReviewState {
      return { ...state, inViewDialog: dialog };
    },
    setShowErrors(value: boolean): ExerciseReviewState {
      return { ...state, showErrors: value };
    },
    suppressReviewDialog(value: boolean): ExerciseReviewState {
      return { ...state, suppressReviewDialog: value };
    },
  };
}

type MethodsType = {
  setConcurrentDialogState: (payload: {
    dialogType: ExerciseDialogs | null;
    name: string;
  }) => ExerciseReviewState;
  setVisibleDialog: (dialog: ExerciseDialogs) => ExerciseReviewState;
  setShowErrors: (value: boolean) => ExerciseReviewState;
  suppressReviewDialog: (value: boolean) => ExerciseReviewState;
};

export default function useExerciseActions() {
  const validate = useSearchParams(ERROR_KEY) === ERROR_KEY_VALUE;
  const [state, methods] = useMethods<MethodsType, ExerciseReviewState>(createMethods, {
    ...initialState,
    showErrors: validate,
  });

  return {
    state,
    methods,
  };
}
